import { type CountryCode as GoogleCountryCode, parsePhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';

import { COUNTRY_CODES, CountryCode } from ':constants/countries';
import { hasNoNullishValues, isNotNil } from ':helpers/type-checkers';

export const formatPhoneNumber = (
    phoneNumber: string,
    country: CountryCode = CountryCode.FRANCE
): { prefix: string; digits: string } | null => {
    const phoneString = phoneNumber.toString();
    const countryCode = COUNTRY_CODES.find((c) => c === country.toUpperCase()) as GoogleCountryCode | undefined;

    if (!countryCode) {
        return null;
    }

    try {
        const { nationalNumber } = parsePhoneNumber(phoneString, countryCode);
        const parsedPhone = parsePhoneNumber(nationalNumber, countryCode);

        return {
            prefix: parsedPhone.countryCallingCode,
            digits: parsedPhone.nationalNumber,
        };
    } catch {
        return null;
    }
};

export const formatPhoneNumberV2 = (phoneNumber: string): { prefix: string; digits: string } | null => {
    try {
        const parsedNumber = parsePhoneNumberFromString(phoneNumber);

        if (!parsedNumber?.countryCallingCode || !parsedNumber?.nationalNumber) {
            return null;
        }

        return {
            prefix: parsedNumber.countryCallingCode,
            digits: parsedNumber.nationalNumber,
        };
    } catch {
        return null;
    }
};

// todo phone: shouldn't we use lib phonenumber-js to format the phone for display ?
export const formatPhoneForDisplay = (phone: { prefix?: string | null; digits?: string | null } | undefined): string | null => {
    const hasAllRequiredProperties = isNotNil(phone) && hasNoNullishValues(phone);
    if (!hasAllRequiredProperties) {
        return null;
    }

    if (phone.prefix === '1') {
        // US phone format
        return `+${phone.prefix} (${phone.digits.substring(0, 3)}) ${phone.digits.substring(3, 6)}-${phone.digits.substring(6)}`;
    }

    return `+${phone.prefix} ${phone.digits[0]} ${phone.digits
        .substring(1)
        .match(/.{1,2}/g) // split string in equal number of chunks of size 2
        ?.join(' ')}`;
};
